import { EnvironmentProviders, importProvidersFrom, Provider } from '@angular/core';
import { TranslationModule } from 'app/shared/directives/language/translation.module';

export const provideTranslate = (): Array<Provider | EnvironmentProviders> => {
	return [importProvidersFrom(TranslationModule)];
};
